/* import __COLOCATED_TEMPLATE__ from './topic-details-modal.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();